<template>
  <div class="loading">
    <span
      class="spinner-border spinner-border-sm"
      role="status"
    />
    <span>{{ i18n('message') }}</span>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  methods: {
    i18n(key, values = null) {
      return this.$t(this.i18nPath(key), values);
    },
    i18nPath(key) {
      return `loading.${key}`;
    }
  }
}
</script>

<style lang="scss">
#core-availability {
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    font-size: $font-size-20px;

    @include media-breakpoint-up(md) {
      padding: 3rem;
    }

    .spinner-border {
      margin-right: 0.5rem;
    }
  }
}
</style>
